export enum AwsCognitoConstants {
  CONFIRM_SIGN_UP = 'CONFIRM_SIGN_UP',
  DONE = 'DONE',
  CONFIRM_RESET_PASSWORD_WITH_CODE = 'CONFIRM_RESET_PASSWORD_WITH_CODE',
  UsernameExistsException = 'UsernameExistsException',
  UserUnAuthenticatedException = 'UserUnAuthenticatedException',
  CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED = 'CONFIRM_SIGN_IN_WITH_NEW_PASSWORD_REQUIRED',
  CONFIRM_SIGN_IN_WITH_TOTP_CODE = 'CONFIRM_SIGN_IN_WITH_TOTP_CODE',
}
